import { PatientCard, PatientPaymentControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author Atish Bagate
 */

interface Params {
  patientPayment: PatientCard;
  xTENANTID?: string;
}

export const useAddPayments = () =>
  useMutationWithLoading(async (params: Params) =>
    new PatientPaymentControllerApi(getConfigObject()).createPatientPayment(
      params.patientPayment,
      params.xTENANTID
    )
  );
